<div class="union-status-page maintenance">
  <div class="status-container">
    <div class="status-content">
      <!-- Header Section -->
      <div class="status-header">
        <div class="status-icon">
          <i class="fas fa-tools"></i>
        </div>
        <h1 class="status-title bangla-heading">সিস্টেম রক্ষণাবেক্ষণ</h1>
        <h2 class="union-name bangla-text" *ngIf="statusData && statusData.unionName">
          {{ statusData.unionName }}
        </h2>
      </div>

      <!-- Message Section -->
      <div class="status-message">
        <div class="message-content">
          <i class="fas fa-cog fa-spin"></i>
          <div class="message-text">
            <p class="primary-message bangla-text">
              আমরা আপনার জন্য সিস্টেম উন্নত করছি। অনুগ্রহ করে কিছুক্ষণ অপেক্ষা করুন।
            </p>
            <p class="secondary-message bangla-text" *ngIf="statusData && statusData.reason">
              <strong>রক্ষণাবেক্ষণের কারণ:</strong> {{ statusData.reason }}
            </p>
            <p class="maintenance-time bangla-text" *ngIf="statusData && statusData.suspendedAt">
              <strong>শুরু হয়েছে:</strong> {{ formatDate(statusData.suspendedAt) }}
            </p>
          </div>
        </div>
      </div>

      <!-- Progress Section -->
      <div class="progress-section">
        <h3 class="progress-title bangla-heading">অগ্রগতি</h3>
        <div class="progress-info">
          <div class="progress-item">
            <div class="progress-icon completed">
              <i class="fas fa-check"></i>
            </div>
            <div class="progress-content">
              <h4 class="bangla-text">সিস্টেম বন্ধ করা হয়েছে</h4>
              <p class="bangla-text">নিরাপদ রক্ষণাবেক্ষণের জন্য সিস্টেম বন্ধ করা হয়েছে</p>
            </div>
          </div>
          
          <div class="progress-item">
            <div class="progress-icon in-progress">
              <i class="fas fa-cog fa-spin"></i>
            </div>
            <div class="progress-content">
              <h4 class="bangla-text">আপডেট চলছে</h4>
              <p class="bangla-text">সিস্টেম আপডেট এবং উন্নতি সাধন করা হচ্ছে</p>
            </div>
          </div>

          <div class="progress-item">
            <div class="progress-icon pending">
              <i class="fas fa-clock"></i>
            </div>
            <div class="progress-content">
              <h4 class="bangla-text">পরীক্ষা করা হবে</h4>
              <p class="bangla-text">আপডেট সম্পন্ন হলে সিস্টেম পরীক্ষা করা হবে</p>
            </div>
          </div>

          <div class="progress-item">
            <div class="progress-icon pending">
              <i class="fas fa-play"></i>
            </div>
            <div class="progress-content">
              <h4 class="bangla-text">পুনরায় চালু করা হবে</h4>
              <p class="bangla-text">সব কিছু ঠিক থাকলে সিস্টেম পুনরায় চালু করা হবে</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Estimated Time Section -->
      <div class="estimated-time-section">
        <div class="time-card">
          <i class="fas fa-clock"></i>
          <div class="time-content">
            <h3 class="bangla-heading">আনুমানিক সময়</h3>
            <p class="time-value bangla-text">আজ {{ estimatedTime }} এর মধ্যে</p>
            <p class="time-note bangla-text">
              <i class="fas fa-info-circle"></i>
              সময় পরিবর্তন হতে পারে
            </p>
          </div>
        </div>
      </div>

      <!-- Instructions Section -->
      <div class="instructions-section">
        <h3 class="instructions-title bangla-heading">এই সময়ে কী করতে পারেন?</h3>
        <div class="instructions-list">
          <div class="instruction-item">
            <i class="fas fa-coffee"></i>
            <div class="instruction-content">
              <h4 class="bangla-text">একটু বিরতি নিন</h4>
              <p class="bangla-text">এই সময়টা কাজে একটু বিরতি নিয়ে চা-কফি খেতে পারেন।</p>
            </div>
          </div>
          
          <div class="instruction-item">
            <i class="fas fa-sync-alt"></i>
            <div class="instruction-content">
              <h4 class="bangla-text">মাঝে মাঝে পেজ রিফ্রেশ করুন</h4>
              <p class="bangla-text">সিস্টেম চালু হয়েছে কিনা দেখার জন্য মাঝে মাঝে পেজ রিফ্রেশ করুন।</p>
            </div>
          </div>

          <div class="instruction-item">
            <i class="fas fa-bell"></i>
            <div class="instruction-content">
              <h4 class="bangla-text">নোটিফিকেশন চেক করুন</h4>
              <p class="bangla-text">আপনার ব্রাউজারে নোটিফিকেশন চালু রাখুন।</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section -->
      <div class="contact-section">
        <h3 class="contact-title bangla-heading">জরুরি প্রয়োজনে যোগাযোগ</h3>
        <div class="contact-methods">
          <div class="contact-method">
            <i class="fas fa-phone-alt"></i>
            <div class="contact-info">
              <span class="contact-label bangla-text">হটলাইন:</span>
              <a href="tel:+8801XXXXXXXXX" class="contact-value">+৮৮০ ১XXX-XXXXXX</a>
            </div>
          </div>
          
          <div class="contact-method">
            <i class="fas fa-envelope"></i>
            <div class="contact-info">
              <span class="contact-label bangla-text">ইমেইল:</span>
              <a href="mailto:support@digitalunion.gov.bd" class="contact-value">support&#64;digitalunion.gov.bd</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-section">
        <button type="button" class="btn-primary-action" (click)="refreshPage()">
          <i class="fas fa-sync-alt"></i>
          <span class="bangla-text">পেজ রিফ্রেশ করুন</span>
        </button>
        
        <button type="button" class="btn-secondary-action" (click)="contactSupport()">
          <i class="fas fa-phone"></i>
          <span class="bangla-text">সাপোর্ট কল করুন</span>
        </button>

        <button type="button" class="btn-tertiary-action" (click)="goToLogin()">
          <i class="fas fa-arrow-left"></i>
          <span class="bangla-text">লগইন পেজে ফিরে যান</span>
        </button>
      </div>

      <!-- Footer -->
      <div class="status-footer">
        <p class="footer-text bangla-text">
          <i class="fas fa-shield-alt"></i>
          Digital Union Management System - আমরা আরও ভাল সেবার জন্য কাজ করে যাচ্ছি
        </p>
      </div>
    </div>
  </div>
</div>